<template>
    <md-card class="island-card">
        <md-card-header>
            <div class="md-title">Select Property</div>
        </md-card-header>

        <md-card-content>
            <md-table v-model="filteredListings" md-sort="name" md-sort-order="asc" md-fixed-header>
            <md-table-toolbar>
                <div class="md-toolbar-section-start">
                <md-button @click="reloadListings" class="md-primary md-icon-button md-raised" :disabled="loadingListing">
                    <div v-if="loadingListing" class="loader-rolling-local_blue"></div>
                    <md-icon v-else>cached</md-icon>
                </md-button>
                </div>
                <md-field md-clearable class="md-toolbar-section-end">
                <md-input placeholder="Search by title, address or info" v-model="searchInput_listing"/>
                </md-field>
            </md-table-toolbar>
            <md-table-row class="clickable" :key="item.maaklerID" slot="md-table-row" slot-scope="{ item }" @click="selectProperty(item)" :class="{'highlighted':item.maaklerID==selectedPropertyId}">
                <md-table-cell md-label="ID" md-numeric><div v-if="item.loading" class="loader-rolling-local_blue"></div>{{ item.maaklerID }}</md-table-cell>
                <md-table-cell md-label="Address">{{ getDisplayAddressGate(item) }}</md-table-cell>
                <md-table-cell md-label="Title">{{ getTitle(item) }}</md-table-cell>
            </md-table-row>
            </md-table>
        </md-card-content>
    </md-card>
</template>
<script>
  import { getProperties, getDisplayAddress } from '@/listingFunctions.js'
  import { filterListingsBasedOn } from '@/searchFunctions.js'
  import { moowLog } from '@/utils/logging/logService'
  export default {
    props: {
    },
    data() {
      return {
        selectedProperty: undefined,
        selectedPropertyId: "",
        searchInput_listing: "",
        listingLoadErrors: [],
        draftListingMetaData: [{listingProgress:0}],    //using array due to its reactivity
        activeListingMetaData: [{listingProgress:0}],   //using array due to its reactivity
      };
    },
    created(){
        this.getAllProperties()
    },
    mounted(){
    },
    watch: {

    },
    computed: {
        filteredListings(){
            if(!this.searchInput_listing) return this.availProperties
            else return filterListingsBasedOn(this.availProperties, this.searchInput_listing)
        },
        availProperties(){
            let ap = this.$store.getters.activeProperties
            let dp = this.$store.getters.draftProperties
            return ap.concat(dp)
        },
        listingLoadProgress(){
            return (this.draftListingMetaData[0].listingProgress + this.activeListingMetaData[0].listingProgress) / 2
        },
        loadingListing(){
            var res = (this.draftListingMetaData[0].listingProgress != 100 || this.activeListingMetaData[0].listingProgress != 100)
            return res
        },
    },

    methods: {
        selectProperty(property){
            this.selectedProperty=property
            this.selectedPropertyId=property.maaklerID
        },
        getSelectedProperty(){
            return this.selectedProperty
        },
        reloadListings(){
            this.$store.commit("CLEAR_ACTIVE_PROPERTIES")
            this.$store.commit("CLEAR_DRAFT_PROPERTIES")
            this.getAllProperties()
        },
        getAllProperties(){
            getProperties("active", this.listingLoadErrors, this.activeListingMetaData)
            getProperties("draft", this.listingLoadErrors, this.draftListingMetaData)
        },
        getStatus(item){
            if(!item || item.loading) return " "
            else if(item.availDet) return item.availDet.status
            else return ""
        },
        getTitle(item){
            if(!item || item.loading) return ""
            else if(item.marketingDet) return item.marketingDet.shortDesc
            else return ""
        },
        getTime(item){
            if(!item || item.loading) return " "
            else if(item.creationDet) {
            return formatTimeToDDMMYY(item.creationDet.createdDate)
            } 
            else return " "
        },
        getDisplayAddressGate(item){
            if(!item || item.loading) return " "
            else if(item.location && item.location.address) return getDisplayAddress(item)
            else return " "
        },
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/global.css';
  
  .highlighted{
    color:white;
    background-color: #4589fa;    
  }

</style>



// WEBPACK FOOTER //
// src/components/property/propertySelector.vue